import React, { Fragment, useEffect } from 'react';
import TopNavBar from './TopBarNav';
import SideNavBar from './SideNavBar';

const Navigation = () => {

  const [isOpen, setOpen] = React.useState(false);

  useEffect(() => {
    if (isOpen) {
      setOpen(false);
    }
  }, [isOpen]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  }

  return (
    <Fragment>
      <TopNavBar onClick={handleToggle}/>
      <SideNavBar isOpen={isOpen}/>
    </Fragment>
  );
};

export default Navigation;
